import { userApi } from '@/apis'
import { getUrlQuery } from '@/utils/url'
import router from '@/router'
import { actionSheetController } from '@ionic/vue'

const urlQuery = getUrlQuery()
const user = {
  namespaced: true,
  state: {
    token: urlQuery.token || localStorage.token || '',
    // roleId: localStorage.userRoleId || '',
    // role: localStorage.userRole ? JSON.parse(localStorage.userRole) : {},  // 角色数据
    // info: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},  // 用户数据
    // token: urlQuery.token || '',
    roleId: '',
    role: {},  // 角色数据
    info: {},  // 用户数据
  },
  mutations: {
    setToKen(state, token) {
      console.log('setToKen', token)
      localStorage.token = token
      state.token = token
    },
    setRoleId(state, roleId) {
      // localStorage.userRoleId = roleId
      state.roleId = roleId
    },
    setRole(state, role) {  // 角色数据
      if (role) {
        // localStorage.userRole = JSON.stringify(role)
      } else {
        // localStorage.userRole = ''
      }
      state.role = role
    },
    setInfo(state, info) {  // 用户数据
      if (info) {
        // localStorage.userInfo = JSON.stringify(info)
      } else {
        // localStorage.userInfo = ''
      }
      state.info = info
    },
  },
  actions: {
    async login(content, body) {
      const { token, rows, user, enterOrgRole } = await userApi.login(body)
      content.commit('setToKen', token)
      content.commit('setInfo', user)
      content.commit('setRole', enterOrgRole)
      content.commit('setRoleId', enterOrgRole.roleId)
      // await content.dispatch('getInfo')
      if (enterOrgRole.roleId == 17) {
        const cListRoleListData = await userApi.cListRoleList()
        const cListRoleListSelect = cListRoleListData.map((item) => ({ text: item.roleName, role: item.id }))
        const actionSheet = await actionSheetController.create({
          cssClass: 'my-custom-class',
          backdropDismiss: false,
          buttons: [
            ...cListRoleListSelect,
          ],
        })
        await actionSheet.present()

        const { role } = await actionSheet.onDidDismiss()
        console.log('role', role)
        content.commit('setRoleId', role)
      } else {
        // content.commit('setRole', enterOrgRole)
        // content.commit('setRoleId', enterOrgRole.roleId)
      }
    },
    async getInfo(content) {
      const { user, enterOrgRole } = await userApi.info()
      console.log('user', user);
      console.log('enterOrgRole', enterOrgRole);
      
      content.commit('setInfo', user)
      content.commit('setRole', enterOrgRole)
      content.commit('setRoleId', enterOrgRole.roleId)
    },
    async logout(content, body) {
      // await userApi.logout(body)
      content.commit('setToKen', '')
      content.commit('setRole', '')
      content.commit('setRoleId', '')
      content.commit('setInfo', '')
    },
  },
  getters: {
    token: state => state.token,
    roleId: state => state.roleId,
    role: state => state.role,
    info: state => state.info,
  }
}

export default user